/* eslint-disable react/forbid-component-props */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { PAYMENT_TYPES } from '../../../config/constants/payment';
import {
  showApplePay,
  showClearpay,
  showGooglePay,
  showPaypal,
  showKlarna,
} from '../../../helpers/payment';
import CTAButton from '../../_generic/button/CTAButton';
import AppleButton from './AppleButton';
import CardButton from './CardButton';
import ClearpayButton from './ClearpayButton';
import GoogleButton from './GoogleButton';
import KlarnaButton from './KlarnaButton';
import PaypalButton from './PaypalButton';

const PaymentTypeButtons = ({
  basketProducts,
  choosePaymentType,
  finalOrderAmount,
  isAuthenticated,
  paymentType,
  paymentInstruments,
}) => {
  const buttonClass = 'payment-button';

  function handleChoose(event, type) {
    // Only handle Enter for keyboard access
    if (event.key && event.key !== 'Enter') return;
    choosePaymentType(type);
  }

  return (
    <>
      <div className="payment-buttons-container">
        <CTAButton
          className={classNames(buttonClass, {
            'payment-button--isActive': paymentType === PAYMENT_TYPES.card,
          })}
          onClick={(event) => handleChoose(event, PAYMENT_TYPES.card)}
          primaryAction={false}
        >
          <CardButton />
        </CTAButton>
        {showPaypal({
          finalOrderAmount,
          isAuthenticated,
          paymentInstruments,
        }) && (
          <CTAButton
            className={classNames(buttonClass, {
              'payment-button--isActive': paymentType === PAYMENT_TYPES.paypal,
            })}
            onClick={(event) => handleChoose(event, PAYMENT_TYPES.paypal)}
            primaryAction={false}
          >
            <PaypalButton />
          </CTAButton>
        )}
        {showGooglePay({
          finalOrderAmount,
          isAuthenticated,
          paymentInstruments,
        }) && (
          <CTAButton
            className={classNames(buttonClass, 'payment-button--google', {
              'payment-button--isActive': paymentType === PAYMENT_TYPES.google,
            })}
            onClick={(event) => handleChoose(event, PAYMENT_TYPES.google)}
            primaryAction={false}
          >
            <GoogleButton />
          </CTAButton>
        )}
        {showApplePay({
          finalOrderAmount,
          isAuthenticated,
          paymentInstruments,
        }) && (
          <CTAButton
            className={classNames(buttonClass, 'apple-pay-btn', {
              'payment-button--isActive': paymentType === PAYMENT_TYPES.apple,
            })}
            onClick={(event) => handleChoose(event, PAYMENT_TYPES.apple)}
            primaryAction={false}
          >
            <AppleButton />
          </CTAButton>
        )}
        {showKlarna({
          basketProducts,
          finalOrderAmount,
          isAuthenticated,
          paymentInstruments,
        }) && (
          <CTAButton
            className={classNames(buttonClass, {
              'payment-button--isActive': paymentType === PAYMENT_TYPES.klarna,
            })}
            onClick={(event) => handleChoose(event, PAYMENT_TYPES.klarna)}
            primaryAction={false}
          >
            <KlarnaButton />
          </CTAButton>
        )}
        {showClearpay({
          basketProducts,
          finalOrderAmount,
          isAuthenticated,
          paymentInstruments,
        }) && (
          <CTAButton
            className={classNames(buttonClass, {
              'payment-button--isActive':
                paymentType === PAYMENT_TYPES.clearpay,
            })}
            onClick={(event) => handleChoose(event, PAYMENT_TYPES.clearpay)}
            primaryAction={false}
          >
            <ClearpayButton />
          </CTAButton>
        )}
      </div>
      <style jsx>{`
        .payment-buttons-container {
          display: flex;
          justify-content: space-around;
          margin: -15px -15px 0 -15px;
        }
      `}</style>
    </>
  );
};

PaymentTypeButtons.propTypes = {
  basketProducts: PropTypes.array.isRequired,
  choosePaymentType: PropTypes.func.isRequired,
  finalOrderAmount: PropTypes.number,
  isAuthenticated: PropTypes.bool,
  paymentInstruments: PropTypes.array,
  paymentType: PropTypes.string,
};

export default PaymentTypeButtons;
